<template>
  <dl :class="classesRoot">
    <template v-for="(item, index) in internalList">
      <div
        :key="index"
        :class="$style.group"
      >
        <UiIcon
          v-if="item.icon"
          :class="$style.icon"
          :name="item.icon"
          :style="item.iconStyles"
        />
        <dt
          v-if="item.term"
          :class="$style.term"
          v-html="item.term"
        />
        <dd
          v-if="item.description"
          :class="$style.description"
          v-html="item.description"
        />
      </div>
    </template>
  </dl>
</template>

<script>
  import UiIcon from '@/components/UiIcon';

  const themeValidator = (_) => [
    'modal',
    'default',
  ].includes(_);

  export default {
    name: 'UiDescriptionList',
    components: {
      UiIcon,
    },
    props: {
      theme: {
        type: String,
        default: 'default',
        validate: themeValidator,
      },
      list: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      classesRoot() {
        const {
          $style,
          theme,
        } = this;
        return {
          [$style.themeDefault]: theme === 'default',
          [$style.themeModal]: theme === 'modal',
        };
      },
      internalList() {
        return this.list.filter(Boolean);
      },
    },
  };
</script>

<style lang="scss" module>
  .themeDefault {
    @include marginY(0);
    .group {
      display: flex;

      &:not(:first-child) {
        margin-top: 10px;
      }
    }

    .icon {
      font-size: 1.3em;
    }

    .term,
    .description {
      margin-left: 8px;
    }
  }
  .themeModal {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    margin-bottom: 30px!important;

    .group {
      display: flex;
      align-items:center;
      margin: 0;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      &:first-child{
        margin-right: 15px;
      }
      &:not(:last-child){
        min-width: 90px;
        margin-bottom: 4px;
      }
      .icon{
        margin-right: 5px;
        width: 13px;
        height: 13px;
      }
      .description{
         margin: 0;
        b{
          font-weight: 500;
        }
      }
    }
  }
</style>
